// extracted by mini-css-extract-plugin
module.exports = {"select":"_3ZV8Y"};